import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { COMPANY } from '../../lib/company'

const currentYear = new Date().getFullYear()

/**
 * 대시보드 하단 푸터 — 콤팩트하게 사업자 정보·법적 링크·저작권 표시.
 * `surface-*` / `ink-*` 토큰을 사용하여 라이트·다크 테마 모두에서 자동 적응.
 */
export default function DashboardFooter() {
  const { t } = useTranslation()
  return (
    <footer className="mt-6 border-t border-surface-elevated/40 bg-surface-deep/40">
      <div className="px-4 md:px-6 py-4 flex flex-col gap-2">
        {/* 1줄: 사업자 정보 */}
        <p className="text-[11px] text-ink-faint leading-relaxed">
          <span className="font-medium text-ink-muted">{COMPANY.name}</span>
          <span className="mx-2 opacity-40">·</span>
          {t('dashboardFooter.ceo')}: {COMPANY.ceo}
          <span className="mx-2 opacity-40">·</span>
          {t('dashboardFooter.businessNumber')}: {COMPANY.brn}
          <span className="mx-2 opacity-40">·</span>
          {t('dashboardFooter.tsreg')}: {COMPANY.tsreg_number}
          <span className="mx-2 opacity-40">·</span>
          <a
            href={`mailto:${COMPANY.email}`}
            className="hover:text-ink-muted transition-colors"
          >
            {COMPANY.email}
          </a>
          <span className="mx-2 opacity-40">·</span>
          {COMPANY.phone}
        </p>

        {/* 2줄: 주소 */}
        <p className="text-[11px] text-ink-faint/80">
          {COMPANY.address}
        </p>

        {/* 3줄: 법적 링크 + 저작권 */}
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] pt-1 border-t border-surface-elevated/30 mt-1">
          <Link to="/terms" className="text-ink-faint hover:text-ink-muted transition-colors">
            {t('dashboardFooter.terms')}
          </Link>
          <span className="text-ink-faint/40">·</span>
          <Link to="/privacy" className="text-ink-faint hover:text-ink-muted transition-colors">
            {t('dashboardFooter.privacy')}
          </Link>
          <span className="text-ink-faint/40">·</span>
          <Link to="/contact" className="text-ink-faint hover:text-ink-muted transition-colors">
            {t('dashboardFooter.support')}
          </Link>
          <span className="text-ink-faint/40">·</span>
          <Link to="/dashboard/billing" className="text-ink-faint hover:text-ink-muted transition-colors">
            {t('dashboardFooter.billing')}
          </Link>

          <span className="ml-auto text-ink-faint/70">
            {t('dashboardFooter.copyright', { year: currentYear, name: COMPANY.service_name })}
          </span>
        </div>
      </div>
    </footer>
  )
}
